<template>
  <v-card class="elevation-12">
    <v-dialog v-model="isActiveDialogAddAttorneyForm">
      <AddCompanyAttorneyForm ref="addCompanyAttorneyForm" @cancel="isActiveDialogAddAttorneyForm = false"/>
    </v-dialog>

    <v-dialog v-model="isActiveDialogEditAttorneyForm">
      <EditCompanyAttorneyForm ref="editCompanyAttorneyForm" @cancel="isActiveDialogEditAttorneyForm = false"/>
    </v-dialog>

    <v-dialog
        v-model="deleteItemDialog"
        max-width="480"
        :persistent="true"
    >
      <v-card>
        <v-card-title class="headline">
          Подтведите удаление
        </v-card-title>
        <v-card-text>
          После удаления, восстановить можно будет только вручным вводом
        </v-card-text>

        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn
              color="warning darken-1"
              text
              @click="() => { deleteItemDialog = false; deletingItemIndex = null; }"
          >
            Отменить
          </v-btn>
          <v-btn
              color="error darken-1"
              text
              @click="() => { approveDelete(); deleteItemDialog = false; } "
          >
            Удалить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card-text>
      <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          class="elevation-1 custom-table"
          :options.sync="options"
          :server-items-length="totalItems"
          :footer-props="{ itemsPerPageOptions: [10, 20, 50, 100, 500] }"
      >

        <template v-slot:item.rowNumber="item">
          <v-chip
              :color="item.item.isSigned ? 'success' : 'warning'"
              text-color="white"
              small
          >
            {{ item.item.rowNumber }}
          </v-chip>
        </template>
        <template v-slot:no-data>
          Ничего не найдено
        </template>
        <template v-slot:top>
          <v-responsive>
          <v-row>
            <v-col cols="12" sm="6" md="3" lg="3" class="py-2">
              <v-text-field v-model="filters.search" label="Поиск" class="mx-4" @input="searchDebounce" :dense="true"/>
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="3" class="py-2">
              <DateInput v-model="filters.startDate"
                         label="Дата начало"
                         @change="onStartChanged"
                         :disabled="false"
                         :dense="true"
              />
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="3" class="py-2">
              <DateInput v-model="filters.endDate"
                         label="Дата конец"
                         @change="onEndChanged"
                         :disabled="false"
                         :dense="true"
              />
            </v-col>
            <v-col cols="12" sm="6" md="3" lg="3" class="py-2">
              <v-autocomplete v-model="filters.isSign"
                              :items="isAttorneySignedOptions"
                              label="Подписать"
                              @change="isSignChanged"
                              :dense="true"
              />
            </v-col>
            <v-col class="text-right py-2">
              <v-btn color="primary" class="mr-2" v-if="signAllButtonAllowed" @click="signAll()">
                <v-icon class="mr-1">{{ icons.mdiPencil }}</v-icon>
                Подписать все на странице
              </v-btn>
              <v-btn fab dark small color="primary" @click="onAddNewAttorney">
                <v-icon>{{ icons.mdiPlus }}</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          </v-responsive>
        </template>
        <template v-slot:item.action="item">
          <v-menu>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs"
                      v-on="on">
                {{ icons.mdiDotsVertical }}
              </v-icon>
            </template>
            <v-list dense>
              <v-list-item v-if="$store.getters.isCertificateLoaded && !item.item.isSigned" @click="sign(item.item)">
                <v-list-item-title>Подписать</v-list-item-title>
              </v-list-item>


              <v-list-item :to="{name: 'company-attorney-view', params: {id: item.item.id}}">
                <v-list-item-title>Открыть</v-list-item-title>
              </v-list-item>
              <v-list-item @click="onEditAttorney(item.item)">
                <v-list-item-title>Редактировать</v-list-item-title>
              </v-list-item>
              <v-list-item @click="onRemoveItemClicked(item.item)">
                <v-list-item-title>Удалить</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>

        <template v-slot:footer.page-text="item">
          <div class="d-inline-flex mr-7">
            <v-text-field
                label="Перейти на страницу"
                type="number"
                v-model="page"/>
          </div>
          <div class="d-inline-flex">
            {{ item.pageStart }} - {{ item.pageStop }} из {{ item.itemsLength }}
          </div>
        </template>
      </v-data-table>
    </v-card-text>

    <v-overlay :value="isSigning">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-card>
</template>

<script>
import AttorneyService from '@/services/attorney.service'
import {mdiPlus, mdiDotsVertical, mdiPencil} from "@mdi/js"
import _ from 'underscore'
import AddCompanyAttorneyForm from "./AddCompanyAttorneyForm";
import EditCompanyAttorneyForm from "./EditCompanyAttorneyForm";
import $bus from '@/eventbus/global.event.bus';
import * as busEvents from '@/eventbus/events';
import moment from 'moment';
import EImzo from '@/plugins/eimzo'
import SignService from '@/services/sign/sign.service'
import DateInput from "../../Input/DateInput";

export default {
  name: "AttorneysList",
  components: {
    AddCompanyAttorneyForm,
    EditCompanyAttorneyForm,
    DateInput
  },
  data() {
    return {
      deleteItemDialog: false,
      deletedAttorneyItem: null,
      isActiveDialogAddAttorneyForm: false,
      isActiveDialogEditAttorneyForm: false,
      icons: {
        mdiPlus,
        mdiDotsVertical,
        mdiPencil
      },
      headers: [
        {
          text: '№',
          value: 'rowNumber',
          sortable: false
        },
        {
          text: 'Ф.И.О',
          value: 'fullName',
          sortable: true
        },
        {
          text: 'Наименования контрагента',
          sortable: false,
          value: 'contractorName'
        },
        {
          text: 'Должность',
          sortable: false,
          value: 'position'
        },
        {
          text: 'Дата выдачи',
          sortable: true,
          value: 'start'
        },
        {
          text: 'Номер доверенность',
          sortable: true,
          value: 'number'
        },
        {
          text: 'Инн сотрудника',
          sortable: false,
          value: 'personInn'
        },
        {
          text: '',
          sortable: false,
          value: 'action'
        }
      ],
      items: [],
      options: {
        sortBy: ['fullName'],
        sortDesc: [true]
      },
      filters: {
        search: '',
        isSign:null,
        startDate: null,
        endDate:null
      },
      totalItems: 0,
      loading: false,
      isSigning: false,
      queryParamDateFormat: 'YYYY-MM-DD',

      isAttorneySignedOptions: [
        {text: 'Да', value: true},
        {text: 'Нет', value: false},
        {text: 'Неважно', value: null}
      ],
    };
  },
  computed: {
    querySearch() {
      return this.$route.query.q ? this.$route.query.q : this.filters.search;
    },
    page: {
      get() {
        return +this.$route.query.page
      },
      set(value) {
        let setterValue = +value;
        let pages = this.totalItems ? Math.ceil(this.totalItems / this.limit) : 0;
        if (Number.isInteger(setterValue)) {
          if (setterValue < 1) {
            this.$set(this.options, 'page', 1);
          } else if (setterValue > pages) {
            this.$set(this.options, 'page', pages);
          } else {
            this.$set(this.options, 'page', setterValue);
          }
        } else {
          this.$set(this.options, 'page', 1);
        }
      }
    },
    limit() {
      return this.$route.query.limit;
    },
    sortDesc() {
      return this.$route.query.desc;
    },
    sortBy() {
      return this.$route.query.sort;
    },
    signAllButtonAllowed() {
      return _.filter(this.items, attorney => {
            return !attorney.isSigned;
          }).length > 0
          && this.$store.getters.isCertificateLoaded;
    }
  },
  methods: {
    searchDebounce: _.debounce(function () {
      this.$set(this.options, 'page', 1);
      this.updateRouteQuery({
        q: this.filters.search,
        isSign:this.filters.isSign,
        page: this.page,
        desc: this.sortDesc,
        sort: this.sortBy,
        limit: this.limit,
        startDate: this.filters.startDate,
        endDate:this.filters.endDate
      });
    }, 500),
    onStartChanged() {
      this.updateRouteQuery({
        q: this.filters.search,
        isSign:this.filters.isSign,
        page: this.page,
        desc: this.sortDesc,
        sort: this.sortBy,
        limit: this.limit,
        startDate: this.filters.startDate,
        endDate:this.filters.endDate
      })
    },
    onEndChanged(){
      this.updateRouteQuery({
        q: this.filters.search,
        isSign:this.filters.isSign,
        page: this.page,
        desc: this.sortDesc,
        sort: this.sortBy,
        limit: this.limit,
        startDate: this.filters.startDate,
        endDate:this.filters.endDate
      })
    },

    isSignChanged(){
      this.updateRouteQuery({
        q: this.filters.search,
        isSign:this.filters.isSign,
        page: this.page,
        desc: this.sortDesc,
        sort: this.sortBy,
        limit: this.limit,
        startDate: this.filters.startDate,
        endDate:this.filters.endDate
      })
    },
    approveDelete() {
      AttorneyService.deleteAttorney(this.deletedAttorneyItem.id);
    },
    onRemoveItemClicked(item) {
      this.deletedAttorneyItem = null;
      this.deletedAttorneyItem = item;
      this.deleteItemDialog = true;
    },

    onAddNewAttorney() {
      this.isActiveDialogAddAttorneyForm = true;
      this.$nextTick(function () {
        this.$refs.addCompanyAttorneyForm.clear();
      });
    },

    onEditAttorney(attorney) {
      this.isActiveDialogEditAttorneyForm = true;
      this.$nextTick(function () {
        this.$refs.editCompanyAttorneyForm.clear();
      });
      this.$nextTick(function () {
        this.$refs.editCompanyAttorneyForm.setAttorney(attorney);
      });
    },

    loadAttorneys() {
      this.loading = true;

      const {page, itemsPerPage} = this.options;
      const {isSign,startDate, endDate} = this.filters
      let perPage = itemsPerPage ? itemsPerPage : 10;
      let queryPage = page ? page : 1;

      let skip = (queryPage - 1) * perPage;
      skip = skip < 0 ? 0 : skip;

      AttorneyService.getAll(
          {
            skip: skip,
            limit: perPage,
            sortBy: this.sortBy,
            desc: this.sortDesc,
            isActive: null,
            contractorInn: null,
            q: this.querySearch,
            isSign: isSign,
            number: null,
            startDate: startDate ? moment(startDate).format(this.queryParamDateFormat) : null,
            endDate: endDate ? moment(endDate).format(this.queryParamDateFormat) : null,
          }
      )
          .then(attorneys => {
            this.totalItems = attorneys.Total;
            let rowNumber = skip;
            this.items = _.map(attorneys.Records, attorney => {
              return {
                rowNumber: ++rowNumber,
                id: attorney.Id,
                fullName: attorney.Fullname,
                personInn: attorney.PersonInn,
                createdOn: moment(attorney.CreatedOn).format('YYYY-MM-DD'),
                number: attorney.Number,
                start: moment(attorney.Start).format('YYYY-MM-DD'),
                end: moment(attorney.End).format('YYYY-MM-DD'),
                position: attorney.Position,
                passportSerial: attorney.PassportSerial,
                passportNumber: attorney.PassportNumber,
                passportIssuer: attorney.PassportIssuer,
                passportIssuedOn: moment(attorney.PassportIssuedOn).format('YYYY-MM-DD'),
                contractorInn: attorney.ContractorInn,
                contractorName: attorney.ContractorName,
                contractNumber: attorney.ContractNumber,
                contractDate: attorney.ContractDate ? moment(attorney.ContractDate).format('YYYY-MM-DD') : '',
                isSigned: attorney.IsSign,
                signedOn: attorney.SignedOn ? moment(attorney.SignedOn) : null,
                signedCertificateSerial: attorney.SignedCertificateSerial
              };
            });
          })
          .catch(() => {
          })
          .finally(() => {
            this.loading = false;
          });
    },

    onCompanyAttorneyUpdated() {
      this.loadAttorneys();
      this.isActiveDialogEditAttorneyForm = false;
      this.isActiveDialogAddAttorneyForm = false;
    },
    onCompanyAttorneyDeleted() {
      this.loadAttorneys();
    },
    updateRouteQuery({q, isSign,page, desc, sort, limit, startDate, endDate}) {
      let startDateStringFormat = startDate ? moment(startDate).format(this.queryParamDateFormat) : null;
      let endDateStringFormat = endDate ? moment(endDate).format(this.queryParamDateFormat) : null;
      let query = {
        q: q,
        isSign:isSign,
        page: page,
        desc: desc,
        sort: sort,
        limit: limit,
        startDate: startDateStringFormat,
        endDate:endDateStringFormat
      };

      let sortDesc = this.$route.query.desc;
      if (sortDesc === "true")
        sortDesc = true;
      else if (sortDesc === "false")
        sortDesc = false;

      if (this.$route.query.q !== q
          || +this.$route.query.page !== page
          || sortDesc !== desc
          || this.$route.query.sort !== sort
          || +this.$route.query.limit !== limit || this.$route.query.endDate !== startDateStringFormat || this.$route.query.endDate !== endDateStringFormat,this.$route.query.isSign !== isSign) {
        this.$router.replace({name: this.$route.name, query: query});
      } else {
        this.loadAttorneys();
      }
    },

    sign(attorney) {
      const vm = this;

      vm.isSigning = true;
      SignService.getAttorneySignProperties(attorney.id)
          .then(response => {
            if (response.data.HashDetail && response.data.HashDetail.FakturaHashCode) {
              EImzo.createPkcs7(response.data.HashDetail.FakturaHashCode, vm.$store.getters.certificate)
                  .then(signResult => {
                    SignService.signAttorney(attorney.id, {
                      fakturaPkcs7: signResult.pkcs7,
                      certificateSerial: signResult.serialNumber
                    })
                        .then(() => {
                          vm.loadAttorneys();
                        })
                        .finally(() => {
                          vm.isSigning = false;
                        })
                  }, () => {
                    vm.isSigning = false;
                  });
            } else {
              vm.isSigning = false;
            }
          }, () => {
            vm.isSigning = false;
          });
    },

    signAll() {
      const vm = this;

      vm.isSigning = true;
      const attorneys = _.filter(vm.items, attorney => {
        return !attorney.isSigned;
      });

      this.singAllIterate(attorneys, 0);
    },

    singAllIterate(attorneys, currentIndex) {
      const vm = this;
      if (currentIndex < attorneys.length) {
        vm.isSigning = true;
        const attorney = attorneys[currentIndex];
        SignService.getAttorneySignProperties(attorney.id)
            .then(response => {
              if (response.data.HashDetail && response.data.HashDetail.FakturaHashCode) {
                EImzo.createPkcs7(response.data.HashDetail.FakturaHashCode, vm.$store.getters.certificate)
                    .then(signResult => {
                      SignService.signAttorney(attorney.id, {
                        fakturaPkcs7: signResult.pkcs7,
                        certificateSerial: signResult.serialNumber
                      })
                          .then(() => {
                            vm.singAllIterate(attorneys, currentIndex + 1);
                          }, () => {
                            vm.isSigning = false;
                          })
                    }, () => {
                      vm.isSigning = false;
                    });
              } else {
                vm.isSigning = false;
              }
            }, () => {
              vm.isSigning = false;
            });
      } else {
        vm.isSigning = false;
        this.loadAttorneys();
      }
    }
  },
  watch: {
    options: {
      handler() {
        let {page, itemsPerPage, sortDesc, sortBy} = this.options;
        let {isSign,startDate,endDate} = this.filters

        this.updateRouteQuery({
          q: this.querySearch,
          isSign:isSign,
          page: page,
          desc: sortDesc[0],
          sort: sortBy[0],
          limit: itemsPerPage,
          startDate: startDate ? startDate : null,
          endDate:endDate ? endDate : null
        });
      },
      deep: true,
    },
    $route: function () {
      this.loadAttorneys();
    },
  },
  created() {
    if (this.$route.query.limit) {
      this.$set(this.options, 'itemsPerPage', +this.$route.query.limit);
    }

    if (this.$route.query.page) {
      this.$set(this.options, 'page', +this.$route.query.page);
    }

    if (this.$route.query.desc) {
      let desc = this.$route.query.desc;
      if (desc === "true")
        desc = true;
      else if (desc === "false")
        desc = false;
      this.options.sortDesc[0] = desc;
    } else {
      this.options.sortDesc[0] = this.$route.query.desc;
    }

    if (this.$route.query.isSign) {
      let isSign = this.$route.query.isSign;
      if (isSign === "true")
        isSign= true;
      else if (isSign === "false")
        isSign = false;
      this.filters.isSign = isSign;
    }

    this.options.sortBy[0] = this.$route.query.sort;

    this.filters.search = this.querySearch;

    $bus.$on(busEvents.CompanyAttorneyAdded, this.onCompanyAttorneyUpdated);
    $bus.$on(busEvents.CompanyAttorneyEdited, this.onCompanyAttorneyUpdated);
    $bus.$on(busEvents.CompanyAttorneyDeleted, this.onCompanyAttorneyDeleted);
  },
  beforeDestroy() {
    $bus.$off(busEvents.CompanyAttorneyAdded, this.onCompanyAttorneyUpdated);
    $bus.$off(busEvents.CompanyAttorneyEdited, this.onCompanyAttorneyUpdated);
    $bus.$off(busEvents.CompanyAttorneyDeleted, this.onCompanyAttorneyDeleted);
  }
}
</script>

<style scoped>

</style>
